export default "__VITE_ASSET__BEh6zpPG__"